"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.brief.topic': '主题/说明',
    'socialMediaPlan.brief.topicPlaceholder': '例如：新夏季系列...',
    'socialMediaPlan.brief.goal': '目标',
    'socialMediaPlan.brief.tone': '语气',
    'socialMediaPlan.brief.contentType': '内容类型',
    'socialMediaPlan.brief.contentType.image': '图片',
    'socialMediaPlan.brief.contentType.carousel': '轮播',
    'socialMediaPlan.brief.contentType.video': '视频',
    'socialMediaPlan.brief.contentType.story': '故事',
    'socialMediaPlan.brief.contentType.thread': '串文',
    'socialMediaPlan.brief.audience': '目标受众',
    'socialMediaPlan.brief.cta': 'CTA',
    'socialMediaPlan.brief.ctaPlaceholder': '例如：立即购买、了解更多、注册...',
    'socialMediaPlan.brief.platforms': '目标平台',
    'socialMediaPlan.brief.platformsHint': 'AI 会针对每个选定的平台分别调整长度、风格和话题标签。',
};
